import { I18nUser } from "./user.i18n";
import { DAYS_OF_WEEK, GENDER } from "./user.types";

export enum UsersDataSourceUID {
    COACH = "COACH",
    CIVILITY = "CIVILITY",
    GENDER = "GENDER",
    AVAILABILITY = "AVAILABILITY"
}

export const genders: { id: GENDER, val: string }[] = [
    { id: GENDER.FEMALE, ...I18nUser().genderFemale.gender },
    { id: GENDER.MALE, ...I18nUser().genderMale.gender }
];

export const civilities: { id: GENDER, val: string }[] = [
    { id: GENDER.MALE, ...I18nUser().genderMale.civility },
    { id: GENDER.FEMALE, ...I18nUser().genderFemale.civility }
];

export const daysOfWeek: { id: DAYS_OF_WEEK, val: string }[] = [
    { id: DAYS_OF_WEEK.MONDAY, ...I18nUser().daysOfWeek.monday },
    { id: DAYS_OF_WEEK.TUESDAY, ...I18nUser().daysOfWeek.tuesday },
    { id: DAYS_OF_WEEK.WEDNESDAY, ...I18nUser().daysOfWeek.wednesday },
    { id: DAYS_OF_WEEK.THURSDAY, ...I18nUser().daysOfWeek.thursday },
    { id: DAYS_OF_WEEK.FRIDAY, ...I18nUser().daysOfWeek.friday },
    { id: DAYS_OF_WEEK.SATURDAY, ...I18nUser().daysOfWeek.saturday },
    { id: DAYS_OF_WEEK.SUNDAY, ...I18nUser().daysOfWeek.sunday }
];
